export const GoogleMapApiConfig = 'AIzaSyCmQD76e4lfXKXDPnahlEN4OjlgUBd3EaU';